import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box
} from '@mui/material';

import Modal_OrderHx from '../Modal_OrderHx';

import MHxEditModal from './MHxEditModal';
import MHxSection from './MHxSection';
import MHxSoapHeader from './MHxSoapHeader';

import {
  sections
} from './data';

import {
  contentSx,
  rootSx
} from './MHxSoapStyles';

const MHxSoap = ({
  readOnly,
  showOrderHx,
  showHeader,
  onToggleExpand
}) => {
  const [openOrderHx, setOpenOrderHx] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  const [expandedSections, setExpandedSections] = useState(() =>
    sections.reduce(
      (result, section) => ({
        ...result,
        [section.title]: true
      }),
      {}
    )
  );

  const handleAccordionChange =
    sectionTitle =>
      (event, isExpanded) => {
        setExpandedSections(previous => ({
          ...previous,
          [sectionTitle]: isExpanded
        }));
      };

  const handleEdit = section => {
    if (readOnly) {
      return;
    }

    setOpenEdit(true);
  };

  return (
    <Box sx={rootSx}>
      {showHeader && (
        <MHxSoapHeader
          readOnly={readOnly}
          showOrderHx={showOrderHx}
          onOpenOrderHx={() =>
            setOpenOrderHx(true)
          }
          onToggleExpand={onToggleExpand}
        />
      )}

      <Box sx={contentSx}>
        {sections.map(section => (
          <MHxSection
            key={section.title}
            section={section}
            expanded={
              Boolean(
                expandedSections[section.title]
              )
            }
            readOnly={readOnly}
            onChange={
              handleAccordionChange(
                section.title
              )
            }
            onEdit={handleEdit}
          />
        ))}
      </Box>

      {!readOnly && showOrderHx && (
        <Modal_OrderHx
          open={openOrderHx}
          onCancel={() =>
            setOpenOrderHx(false)
          }
        />
      )}

      {!readOnly && (
        <MHxEditModal
          open={openEdit}
          onClose={() =>
            setOpenEdit(false)
          }
        />
      )}
    </Box>
  );
};

MHxSoap.propTypes = {
  readOnly: PropTypes.bool,
  showOrderHx: PropTypes.bool,
  showHeader: PropTypes.bool,
  onToggleExpand: PropTypes.func
};

MHxSoap.defaultProps = {
  readOnly: false,
  showOrderHx: true,
  showHeader: true,
  onToggleExpand: null
};

export default MHxSoap;